import http from "./http";

export default {
    getEmeterInfo(params){
        return http.post("business-demo/emeter/queryEmeterInfo", params);
    },

    controlIntervals(params){
        return http.get("business-demo/emeter/controlIntervals", {params});
    },

    controlStatus(params){
        return http.get("business-demo/emeter/controlStatus", {params});
    },
}
